import React from "react";
import { Management } from "../containers/management/Management";

export function ManagementPage() {
  return <Management/>;
}
